import brandConfig from '@/utils/brandConfig'
import $storage from '@/utils/storage'
import '@/utils/comefrom'
import '@/config/global'
import Vue from 'vue'
import App from './App.vue'
import '@/style/index.less'
import store from './store'
import router from './router'
import api from '@/api'
import directives from '@/directives'
import '@/icons'
import { Toast, Dialog, Lazyload } from 'vant'
import Change from '@/directives/change'
import '@babel/polyfill'
import VConsole from 'vconsole'
import '@/utils/umengMTA'
import '@/utils/components'
import { formatPrice, relationDict } from '@/utils/filters'
import '@/utils/event'
import customerService from '@/utils/customerService'
import MyButton from '@/base/Button/MyButton.vue'
import '@/utils/polyfill'
import "@/utils/initMini"
import '@/utils/graphJump'

import '@/utils/initFlutterPlugin'
import '@/utils/dsfunny.js'
// import fundebugVue from '@/utils/fundebug'

import VueHtml2Canvas from 'vue-html2canvas'
import { setUA } from '@/utils/channel'


Vue.use(VueHtml2Canvas)

// 保存珍爱网标识
window.$storage = Vue.prototype.$storage = $storage
Vue.use(directives) // 注册全局自定义指令
Vue.component('MyButton', MyButton)
Vue.use(Change)
Vue.use(Toast)
Toast.setDefaultOptions('loading', {
  forbidClick: true,
  duration: 1000 * 10,
  loadingType: 'spinner'
})
Vue.use(Dialog)
Vue.config.devtools = true
Vue.use(Lazyload)
Vue.config.productionTip = false
Vue.filter('G_formatPrice', formatPrice)
Vue.filter('G_relationDict', relationDict)
// Vue.config.errorHandler = function(err, vm, info) {
//   console.log(err, vm, info)
// }
Vue.prototype.$api = api
Vue.prototype.$customerService = customerService
Vue.prototype.$brandConfig = brandConfig
new Vue({
  router,
  store,
  render: (render) => render(App)
}).$mount('#app')

if (location.href.match(/console=1/)) {
  /* eslint-disable */
  new VConsole()
  /* eslint-disable */
}
// setTimeout(() => {
// new fundebugVue(Vue)
// }, 2000)
setUA()

import MonitJsSdk from '@/utils/monit-js-sdk.esm.js'
function monitorJs() {
  try {
    if (process.env.VUE_APP_FLAG === 'production') {
      MonitJsSdk.init({
        dsn: 'https://test.daishutijian.com:8233',
        key: 'health_fe',
        Vue: Vue,
        ignoreErrType: ['script_error', 'resource_error', 'unhandledrejection']
      })
    }
  } catch (error) {
    console.log(error)
  }
}

monitorJs()
